export const drawerWidth = 250;

// export const UPLOAD_PRESET = 'sfnboslv';
// export const CLOUD_NAME = 'fivegstore';
export const UPLOAD_PRESET = 'ltib3a5s';
export const CLOUD_NAME = 'jadwalio';
export const imageUploadOptions = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1280,
  useWebWorker: true,
};
